import { Injectable } from '@angular/core';

import { EnableClassTelemetry } from 'app/services/otel.service';
import { Breakdown } from '../../models/predictive.models';

@EnableClassTelemetry()
@Injectable()
export class PredictiveSimulationService {
  simulate(allBreakdown: Breakdown, subBreakdowns: Breakdown[]): void {
    let allSimulated = this.calculateSimulated(allBreakdown);

    const allBreakdownSimulatedForSubs = this.calculateSimulated(allBreakdown, false);

    for (const subBreakdown of subBreakdowns) {
      const breakdownSimulated = this.calculateSimulated(subBreakdown);

      allSimulated += breakdownSimulated;

      const subSimulated = breakdownSimulated + allBreakdownSimulatedForSubs;

      subBreakdown.simulated = this.getSimulated(subBreakdown, subSimulated);
    }

    allBreakdown.simulated = this.getSimulated(allBreakdown, allSimulated);
  }

  reset(...breakdowns: Breakdown[]): void {
    breakdowns.forEach((breakdown) => {
      breakdown.simulated = null;

      breakdown.drivers.forEach((driver) => (driver.simulated = null));
    });
  }

  private calculateSimulated(breakdown: Breakdown, weight = true): number {
    let simulated = 0;

    for (const driver of breakdown.drivers.filter((d) => d.simulated != null)) {
      let driverScore = (driver.simulated - driver.current) * driver.importance;
      if (weight) {
        driverScore *= breakdown.weight;
      }
      simulated += driverScore;
    }

    return simulated;
  }

  private getSimulated(breakdown: Breakdown, simulated: number): number | null {
    if (simulated !== 0) {
      return breakdown.value + simulated;
    }

    return null;
  }
}
